// フェードイン
window.addEventListener('load', function () {
    const fadeInTargets = document.querySelectorAll('.c_fadeIn, .c_fadeIn__no-bg');
  
    function checkFadeIn() {
      const scrollY = window.scrollY;
      const windowHeight = window.innerHeight;
  
      fadeInTargets.forEach(el => {
        const pos = el.getBoundingClientRect().top + scrollY;
        if (scrollY > pos - windowHeight + windowHeight / 5) {
          el.style.opacity = '1';
        } else {
          el.style.opacity = '0';
        }
      });
    }
  
    checkFadeIn();
    window.addEventListener('scroll', checkFadeIn);
  });
  